import { takeEvery } from "redux-saga/effects";
import { getEntitySaga } from "./apiSagas.js";

import { CHARGE, USAGE, MEASUREMENTS } from "../actions/actionConstants.js";

// -- WATCHERS -- //

export function* watchUsageSagas() {
  yield takeEvery(CHARGE.GET, getEntitySaga, CHARGE, { showErrorModal: false });

  yield takeEvery(USAGE.GET, getEntitySaga, USAGE, { showErrorModal: false });

  yield takeEvery(MEASUREMENTS.GET, getEntitySaga, MEASUREMENTS, {
    showErrorModal: false
  });
}
